import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily:
      '"Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: {
      fontFamily: '"Manrope Variable", sans-serif',
      fontWeight: 800,
      letterSpacing: '-0.03em',
      color: '#0B2545',
    },
    h2: {
      fontFamily: '"Manrope Variable", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.025em',
      color: '#0B2545',
    },
    h3: {
      fontFamily: '"Manrope Variable", sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.02em',
      color: '#0B2545',
    },
    h4: {
      fontFamily: '"Manrope Variable", sans-serif',
      fontWeight: 600,
      letterSpacing: '-0.015em',
      color: '#0B2545',
    },
    h5: {
      fontFamily: '"Manrope Variable", sans-serif',
      fontWeight: 600,
      color: '#0B2545',
    },
    h6: {
      fontFamily: '"Manrope Variable", sans-serif',
      fontWeight: 600,
      color: '#0B2545',
    },
    subtitle1: {
      fontFamily: '"Inter Variable", sans-serif',
      color: '#475569',
    },
    subtitle2: {
      fontFamily: '"Inter Variable", sans-serif',
      color: '#475569',
    },
    body1: {
      fontFamily: '"Inter Variable", sans-serif',
      color: '#0F172A',
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: '"Inter Variable", sans-serif',
      color: '#475569',
      lineHeight: 1.5,
    },
    button: {
      fontFamily: '"Inter Variable", sans-serif',
      fontWeight: 600,
      textTransform: 'none',
      letterSpacing: '0.01em',
    },
  },
  palette: {
    primary: {
      main: '#0B2545', // Executive Navy (Stitch primary)
      light: '#1B60A2',
      dark: '#001026',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#005596', // Rich Cobalt (Stitch secondary)
      light: '#1B60A2',
      dark: '#003866',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#00B4D8', // Electric Cyan telemetry accent
      light: '#4CD6FB',
      dark: '#007A94',
      contrastText: '#0B2545',
    },
    background: {
      default: '#F8FAFC', // Alabaster Base Canvas
      paper: '#FFFFFF',
    },
    text: {
      primary: '#0F172A', // Slate 900 (High contrast AAA)
      secondary: '#475569', // Slate 600 (WCAG AA compliant > 4.5:1)
    },
    divider: 'rgba(15, 23, 42, 0.08)',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 20px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(11, 37, 69, 0.15)',
          },
        },
        containedPrimary: {
          backgroundColor: '#0B2545',
          '&:hover': {
            backgroundColor: '#005596',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 1px 3px 0 rgba(11, 37, 69, 0.04), 0 1px 2px -1px rgba(11, 37, 69, 0.04)',
          border: '1px solid rgba(15, 23, 42, 0.08)',
          transition: 'all 0.2s ease-in-out',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#0B2545',
          color: '#FFFFFF',
        },
      },
    },
  },
});

export default theme;
